import { FC } from 'react';
import { Slider } from '@mui/material';

interface SliderProps {
  fieldName?: string;
  disabled?: boolean;
  value: number;
  onChange: (event: Event, value: number | number[]) => void;
  max?: number;
  min?: number;
}

export const DefaultSlider: FC<SliderProps> = ({ disabled, fieldName, value, onChange, max, min }) => {
  const marks = [];
  marks.push({
    value: min ?? 0,
    label: min ?? 0,
  });
  disabled && marks.push({ value: value, label: value });
  marks.push({
    value: max ?? 100,
    label: max ?? 100,
  });

  return (
    <Slider
      data-cy={fieldName + '-field'}
      disabled={disabled}
      value={value}
      onChange={onChange}
      aria-label="Default"
      valueLabelDisplay="auto"
      marks={marks}
    />
  );
};
